import { render, staticRenderFns } from "./AllTenancyRecords.vue?vue&type=template&id=588b5329&scoped=true&"
import script from "./AllTenancyRecords.vue?vue&type=script&lang=js&"
export * from "./AllTenancyRecords.vue?vue&type=script&lang=js&"
import style0 from "styles/viewAll.scss?vue&type=style&index=0&id=588b5329&lang=scss&scoped=true&"
import style1 from "styles/dashboard/style.scss?vue&type=style&index=1&id=588b5329&lang=scss&scoped=true&"
import style2 from "styles/dashboard/datatable.scss?vue&type=style&index=2&id=588b5329&lang=scss&scoped=true&"
import style4 from "./AllTenancyRecords.vue?vue&type=style&index=4&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b5329",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588b5329')) {
      api.createRecord('588b5329', component.options)
    } else {
      api.reload('588b5329', component.options)
    }
    module.hot.accept("./AllTenancyRecords.vue?vue&type=template&id=588b5329&scoped=true&", function () {
      api.rerender('588b5329', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tenants/AllTenancyRecords.vue"
export default component.exports